import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Login from "./userlogin"; // Import the Login component
import Register from "./userregister"; // Import the Register component
import Canvas from "./connectdot";

const LoginRegisterPopup = () => {
  const [modalOpen, setModalOpen] = useState({
    login: false,
    register: false,
    forgotPassword: false,
  });

  const [loggedInUser, setLoggedInUser] = useState(
    localStorage.getItem("loggedInUser") || null
  );

  useEffect(() => {
    // Listen for changes in local storage (e.g., when other tabs log in or out)
    const handleStorageChange = (event) => {
      if (event.key === "loggedInUser") {
        setLoggedInUser(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const closeModal = () => {
    setModalOpen({
      login: false,
      register: false,
      forgotPassword: false,
    });
  };

  // Effect to persist login status in local storage
  useEffect(() => {
    if (loggedInUser) {
      localStorage.setItem("loggedInUser", loggedInUser);
    } else {
      localStorage.removeItem("loggedInUser");
    }
  }, [loggedInUser]);

  return (
    <div>
      <ul className="navbar-nav ml-auto">
        {/* Conditionally render buttons based on user login status */}
        {loggedInUser ? (
          <li className="nav-item">
            <button className="nav-link text-white" onClick={() => setLoggedInUser(null)}>
              Logout ({loggedInUser})
            </button>
          </li>
        ) : (
          <>
            <li className="nav-item">
              <button
                className="nav-link text-white"
                onClick={() => setModalOpen((prevState) => ({ ...prevState, login: true }))}
              >
                Login
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link text-white"
                onClick={() => setModalOpen((prevState) => ({ ...prevState, register: true }))}
              >
                Register
              </button>
            </li>
          </>
        )}
      </ul>

      {modalOpen.login && (
        <Modal show={modalOpen.login} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fab fa-instagram"></i> Login
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Login closeModal={closeModal} setLoggedInUser={setLoggedInUser} />
          </Modal.Body>
          <Canvas />
        </Modal>
      )}

      {modalOpen.register && (
        <Modal show={modalOpen.register} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Register</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Register closeModal={closeModal} setLoggedInUser={setLoggedInUser} />
          </Modal.Body>
          <Canvas />
        </Modal>
      )}
    </div>
  );
};

export default LoginRegisterPopup;
